export const languages = [
    {id:'en',  locale: 'en', name: 'English' },
    { id: 'de', locale: 'de', name: 'German' },
    { id: 'sv', locale: 'sv', name: 'Swedish' }
];

export const locales = ['en' , 'de', 'sv'];